import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import {BehaviorSubject, Subject} from "rxjs";
import { Observable } from "rxjs";
import {map, tap} from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import * as Cookies from 'js-cookie';
import {ConstantsService as constants} from "../../services/constants/constants.service";

export interface planState{
    current_time:any,
    valid_from:any,
    valid_till:any,
    user_role:any,
    type:any,
    message:any,
    active:any,
    payment_status:any
}
@Injectable({
    providedIn: 'root'
  })
export class PlanService {
    planState:planState = {
        current_time:' ',
        valid_from:' ',
        valid_till:' ',
        user_role:' ',
        type:' ',
        message:' ',
        active:' ',
        payment_status:' '
    }
    requestGuard = false as any;
    private sfdcIdSubject = new BehaviorSubject<any>(null);
    private sfdcId$ = this.sfdcIdSubject.asObservable();

    constructor(private apiservice: ApiService){
    }
    getPlan(filteredPlans):any {
        let params = new HttpParams().set('filteredPlans', filteredPlans)
        const endpoint = `organisation/plan`
        return this.apiservice.get(endpoint, {params: params}).pipe(map(data => data));
    }

    postLog(data): any{
        const endpoint = `log_request/`
        return this.apiservice.post(endpoint, data).pipe(map(data => data));
    }

    deprecatedGetSFDCid():any{
        const endpoint = `organisation/sfdc_id`
        return this.apiservice.get(endpoint).pipe(map(data=>data))
    }
    getSFDCid(): Observable<any> {
    if (!this.sfdcIdSubject.value) {
      const endpoint = `organisation/sfdc_id`;
      this.apiservice.get(endpoint).pipe(
        map(data => data),
        tap(data => this.sfdcIdSubject.next(data))
      ).subscribe();
    }
    return this.sfdcId$;
  }
    setPlan(state):any{
        this.planState.current_time = state.current_time
        this.planState.user_role = state.role,
        this.planState.message = state.message,
        this.planState.type = state.type
        this.planState.valid_from = state.valid_start_time
        this.planState.valid_till = state.valid_end_time
        this.planState.current_time = state.current_time
        this.planState.active = state.active
        this.planState.payment_status = state.payment_status
        return this.planState
    }
    setGuard(guard){
        this.requestGuard = guard
        return this.requestGuard
    }

    getGuard(){
        return this.requestGuard
    }
    getPlanState(){
        return this.planState
    }
}
